import { render } from "./typeIndex.vue?vue&type=template&id=b45544d2&scoped=true"
import script from "./typeIndex.vue?vue&type=script&lang=js"
export * from "./typeIndex.vue?vue&type=script&lang=js"

import "./typeIndex.vue?vue&type=style&index=0&id=b45544d2&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45544d2"]])

export default __exports__